import type { EmbedSearchWidgetMessage } from '#/modules/embedSearchWidget/types/messages/EmbedSearchWidgetMessage';

export function postEmbedSearchWidgetMessage(
  message: EmbedSearchWidgetMessage,
) {
  window.parent.postMessage(JSON.stringify(message), {
    targetOrigin: '*',
  });
}
